export default __webpack_public_path__ + "static/gc-71987c21c9de038949540340f55b428d.png";